import React from 'react'
import styled from 'styled-components';
import styles from '../../../utility/styles';
import { VictoryPie } from 'victory';
import Text from '../Text';

const SIZE = 75;
const THICKNESS = 8;

const returnColor = ({ datum: { type } }) => {
    switch (type) {
        case 'low':
            return styles.colors.usage.low;
        case 'medium':
            return styles.colors.usage.medium;
        case 'high':
            return styles.colors.usage.high;
        case 'idle':
            return styles.colors.usage.idle;
        case 'unused':
            return styles.colors.chargingGreen;
        case 'remaining':
            return styles.colors.socGreen;
    }
}

const StyledRow = styled.div`
    display: flex;
    align-items: center;
    flex: 1;
    
`

const Wrapper = styled.div`
    display: flex;
    align-items: center;
    flex: 1;
    justify-content: center;
    background-color: ${styles.colors.darkGray};
    border-radius: 8px;
    margin-bottom: 24px;
`

const ChartWrapper = styled.div`
    width: ${SIZE * 2}px;
    height: ${SIZE * 2}px;
    position: relative;
`;

const TextWrapper = styled.div`
    background-color: none;
    display: flex;
    flex-direction: column;
    margin-left: 24px;
    flex: 1;
`;

export default function Usage({ data }) {
    console.log(data);
    const {
        range_lost_by_drive_efficiency: { high, low, medium, phantom },
        remaining_range,
        unused_range,
        est_max_range,
        unplugged,
        distance_traveled_string,
        start_percent,
        end_percent,
    } = data;

    const innerRadius = React.useCallback(({ datum }) => datum.type === 'unused' || datum.type === 'remaining' ? SIZE / 2 - (THICKNESS / 2) : SIZE / 2 - THICKNESS, []);
    const radius = React.useCallback(({ datum }) => datum.type === 'unused' || datum.type === 'remaining' ? SIZE / 2 - THICKNESS : SIZE / 2, []);

    return (
        <Wrapper>
            <ChartWrapper>
                <VictoryPie
                    width={SIZE * 1.1}
                    height={SIZE * 1.1}
                    data={[
                        { type: 'low', value: low },
                        { type: 'medium', value: medium },
                        { type: 'high', value: high },
                        { type: 'idle', value: phantom },
                        { type: 'unused', value: unused_range },
                        { type: 'remaining', value: remaining_range },
                    ]}
                    y='value'
                    labels={[]}
                    style={{
                        data: {
                            fill: returnColor,
                        }
                    }}
                    {...{ radius, innerRadius }}
                />
            </ChartWrapper>
            <TextWrapper>
                <Text.Heading type='h5' variant='bold' style={{ marginBottom: '4px' }}>{unplugged}</Text.Heading>
                <StyledRow>
                    <StyledRow>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" style={{ marginRight: '4px' }}>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M2.34337 10.7036C2.34366 10.869 2.47789 11.003 2.64337 11.003H10.0318H10.4497H12.0333C12.1989 11.003 12.3333 10.8687 12.3333 10.703V5.29696C12.3333 5.13128 12.1989 4.99696 12.0333 4.99696H10.3333H10.1137H2.63379C2.4679 4.99696 2.3335 5.1316 2.33379 5.2975L2.34337 10.7036ZM1.62972 12H9.22735H10.2092H13.0333C13.1989 12 13.3333 11.8657 13.3333 11.7V10H14.0333C14.1989 10 14.3333 9.86569 14.3333 9.7V6.3C14.3333 6.13431 14.1989 6 14.0333 6H13.3333V4.29999C13.3333 4.1343 13.1989 4 13.0333 4H11.3588H10.3547H1.63325C1.46757 4 1.33325 4.13431 1.33325 4.3V11.7C1.33325 11.8657 1.46404 12 1.62972 12ZM3.19993 5.66667C3.08947 5.66667 2.99993 5.75621 2.99993 5.86667V10.1333C2.99993 10.2438 3.08947 10.3333 3.19993 10.3333H9.4666C9.57705 10.3333 9.6666 10.2438 9.6666 10.1333V5.86667C9.6666 5.75621 9.57705 5.66667 9.4666 5.66667H3.19993Z" fill={styles.colors.white} />
                        </svg>
                        <Text.Tiny variant='bold'>{start_percent}%</Text.Tiny>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M10.7801 8.66667L8.39341 11.06L9.33341 12L13.3334 8L9.33341 4L8.39341 4.94L10.7801 7.33333H2.66675V8.66667H10.7801Z" fill={styles.colors.white} />
                        </svg>
                        <Text.Tiny variant='bold'>{end_percent}%</Text.Tiny>
                    </StyledRow>
                    <StyledRow>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M2.49997 5.50002V7.00002C2.49997 7.13263 2.55264 7.2598 2.64641 7.35357C2.74018 7.44734 2.86736 7.50002 2.99997 7.50002C3.13257 7.50002 3.25975 7.44734 3.35352 7.35357C3.44729 7.2598 3.49997 7.13263 3.49997 7.00002V5.50002C3.50223 5.47507 3.50223 5.44997 3.49997 5.42502C3.90416 5.30872 4.25275 5.05035 4.48159 4.69746C4.71042 4.34456 4.8041 3.92089 4.74537 3.50442C4.68665 3.08794 4.47948 2.70669 4.16199 2.43083C3.8445 2.15496 3.43806 2.00305 3.01747 2.00305C2.59687 2.00305 2.19043 2.15496 1.87294 2.43083C1.55545 2.70669 1.34828 3.08794 1.28956 3.50442C1.23083 3.92089 1.32451 4.34456 1.55334 4.69746C1.78218 5.05035 2.13077 5.30872 2.53497 5.42502C2.52074 5.44874 2.50901 5.47388 2.49997 5.50002ZM2.24997 3.75002C2.24997 3.55111 2.32898 3.36034 2.46964 3.21969C2.61029 3.07904 2.80105 3.00002 2.99997 3.00002C3.19888 3.00002 3.38964 3.07904 3.5303 3.21969C3.67095 3.36034 3.74997 3.55111 3.74997 3.75002C3.74997 3.94959 3.67068 4.141 3.52956 4.28212C3.38844 4.42324 3.19704 4.50252 2.99747 4.50252C2.79789 4.50252 2.60649 4.42324 2.46537 4.28212C2.32425 4.141 2.24497 3.94959 2.24497 3.75002H2.24997ZM14.75 8.25002C14.7491 7.92688 14.6585 7.61032 14.4883 7.33563C14.3181 7.06094 14.075 6.8389 13.7861 6.69426C13.4971 6.54962 13.1736 6.48806 12.8517 6.51643C12.5299 6.54481 12.2222 6.66201 11.963 6.85497C11.7038 7.04793 11.5032 7.30908 11.3837 7.6093C11.2642 7.90953 11.2304 8.23705 11.2861 8.55536C11.3417 8.87367 11.4847 9.17027 11.699 9.4121C11.9134 9.65393 12.1907 9.8315 12.5 9.92502C12.4976 9.94996 12.4976 9.97507 12.5 10V11.5C12.5 11.6326 12.5526 11.7598 12.6464 11.8536C12.7402 11.9473 12.8674 12 13 12C13.1326 12 13.2598 11.9473 13.3535 11.8536C13.4473 11.7598 13.5 11.6326 13.5 11.5V10C13.5022 9.97507 13.5022 9.94997 13.5 9.92502C13.8594 9.81585 14.1744 9.59421 14.3985 9.29269C14.6226 8.99117 14.7441 8.6257 14.745 8.25002H14.75ZM13 9.00002C12.8011 9.00002 12.6103 8.921 12.4696 8.78035C12.329 8.6397 12.25 8.44893 12.25 8.25002C12.25 8.05111 12.329 7.86034 12.4696 7.71969C12.6103 7.57904 12.8011 7.50002 13 7.50002C13.1989 7.50002 13.3896 7.57904 13.5303 7.71969C13.6709 7.86034 13.75 8.05111 13.75 8.25002C13.75 8.44893 13.6709 8.6397 13.5303 8.78035C13.3896 8.921 13.1989 9.00002 13 9.00002ZM13 14H9.99997C9.46953 14 8.96083 13.7893 8.58575 13.4142C8.21068 13.0392 7.99997 12.5305 7.99997 12V10.5C7.99997 10.2348 7.89461 9.98045 7.70707 9.79291C7.51954 9.60538 7.26518 9.50002 6.99997 9.50002H2.99997C2.86736 9.50002 2.74018 9.44734 2.64641 9.35357C2.55264 9.2598 2.49997 9.13263 2.49997 9.00002C2.49997 8.86741 2.55264 8.74023 2.64641 8.64647C2.74018 8.5527 2.86736 8.50002 2.99997 8.50002H6.99997C7.5304 8.50002 8.03911 8.71073 8.41418 9.08581C8.78925 9.46088 8.99997 9.96959 8.99997 10.5V12C8.99997 12.2652 9.10532 12.5196 9.29286 12.7071C9.4804 12.8947 9.73475 13 9.99997 13H13C13.1326 13 13.2598 13.0527 13.3535 13.1465C13.4473 13.2402 13.5 13.3674 13.5 13.5C13.5 13.6326 13.4473 13.7598 13.3535 13.8536C13.2598 13.9473 13.1326 14 13 14Z" fill={styles.colors.white} />
                        </svg>
                        <Text.Tiny variant='bold'>{distance_traveled_string}</Text.Tiny>
                    </StyledRow>
                </StyledRow>
            </TextWrapper>
        </Wrapper>
    )
}
